// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .dashboard-blade-nav backdrop-filter removed for sharpness */

.dashboard-blade-nav::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 1;
}

.nav-item-hover {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-item-hover:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Smooth scrollbar for the navigation */
.dashboard-blade-nav::-webkit-scrollbar {
  width: 4px;
}

.dashboard-blade-nav::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.dashboard-blade-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.dashboard-blade-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardBlade/DashboardBlade.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;+FAC6F;EAC7F,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* .dashboard-blade-nav backdrop-filter removed for sharpness */\n\n.dashboard-blade-nav::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n              radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.nav-item-hover {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.nav-item-hover:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Smooth scrollbar for the navigation */\n.dashboard-blade-nav::-webkit-scrollbar {\n  width: 4px;\n}\n\n.dashboard-blade-nav::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n.dashboard-blade-nav::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.dashboard-blade-nav::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
